import React, {useContext, useState} from 'react';
import HeaderActions from '../../../common/DasnboardHeader/HeaderActions';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import ConservationTable from './ConservationTable';
import {useNavigate} from 'react-router-dom';
import {StateContext} from '../../../store';
import NewConservationTable from './NewConservationTable';
import {styleBg} from '../../../common/Models/Validations';
import AssuredWorkloadRoundedIcon from '@mui/icons-material/AssuredWorkloadRounded';
import DashboardHeader from '../../../common/DasnboardHeader/DashboardHeader';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

function CustomTabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{pt: 3}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ConservationMain(props) {
  const navigate = useNavigate();
  const {role} = useContext(StateContext);
  const [value, setValue] = React.useState(0);
  const [meta, setMeta] = useState({total: 0});

  const handleOpen = () => {
    navigate('/management/conservator/create');
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleDescription = () => {
    if (value === 0) {
      return 'Total Pending Conservation'
    } else if (value === 1) {
      return 'Total Approved Conservation'
    } else if (value === 2) {
      return 'Total Rejected Conservation'
    } else {
      return 'Total Resubmitted Conservation'
    }
  }

  return (
    <PageWrapper>
      {role?.id === 7 ?
        <Box>
        {/* <HeaderActions title={'Conserve Artifacts'} handleOpen={handleOpen} btnName={'+ Conservation'}/> */}
          <DashboardHeader title={'Conserve Artifacts'} total={meta?.total} IconName={AssuredWorkloadRoundedIcon} iconColor={'#ff9653'}
                           desc={handleDescription()} handleOpen={handleOpen} btnName={'+ Conservation'}/>
        </Box> :
        <DashboardHeader total={meta?.total} IconName={AssuredWorkloadRoundedIcon} iconColor={'#ff9653'}
                         desc={handleDescription()}/>
      }
      <Box>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          {[
            {label: 'PENDING CONSERVATIONS', index: 0},
            {label: 'APPROVED CONSERVATIONS', index: 1},
            {label: 'REJECTED CONSERVATIONS', index: 2},
            role?.id === 7 && {label: 'RESUBMITTED CONSERVATIONS', index: 3},
          ].filter(Boolean).map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              {...a11yProps(tab.index)}
              sx={{width: 250, ...styleBg(index, value)}}
            />
          ))}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {role?.id === 2 ?
          <NewConservationTable meta={meta} setMeta={setMeta}/> :
          <ConservationTable status={'requested'} meta={meta} setMeta={setMeta}/>}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ConservationTable status={'approved'} meta={meta} setMeta={setMeta}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ConservationTable status={'rejected'} meta={meta} setMeta={setMeta}/>
      </CustomTabPanel>
      {role?.id === 7 &&
      <CustomTabPanel value={value} index={3}>
        <ConservationTable status={'resubmitted'} meta={meta} setMeta={setMeta}/>
      </CustomTabPanel>
      }
    </PageWrapper>
  );
}